import { analyticsUtils } from 'utils/analytics-utils';
import { getPathname } from 'utils/get-pathname';

// Событие срабатывает при попадании баннера замера во viewport.

export const gaViewMeasurementBanner = ({
  catalogueLevel,
  price,
  elementName,
  productId,
}: {
  catalogueLevel: number;
  price?: number | null;
  elementName: string;
  productId: string;
}) => {
  const path = getPathname();

  return analyticsUtils.sendEvent('GA:impressions', {
    elementType: 'product',
    elementBlock: `${path}:lvl${catalogueLevel}`, // блок, в котором расположен элемент
    elementName,
    productName: 'Профессиональный замер', // название услуги
    productId, // артикул услуги
    productPrice: price?.toString(), // стоимость единицы товара
    productPosition: '1', // позиция товара в блоке при подсчете слева-направо от 1
    productBelong: 'LeroyMerlinServices',
  });
};
